import styled, { css } from 'styled-components';

export const List = styled.ul`
    ${({ theme }) => css`
        list-style: none;
        display: grid;
        gap: 1rem;
        padding: 0;
        grid-template-columns: repeat(1, 1fr);

        @media ${theme.breakpoints.medium.media} {
            grid-template-columns: repeat(2, 1fr);
        }

        @media ${theme.breakpoints.large.media} {
            grid-template-columns: repeat(4, 1fr);
        }
    `}
`;

export const Heading = styled.h2`
    margin-bottom: 0;
`;
